import {Doctor, Dept, DeptOptions} from "../components/dashboard";

export const EVENT_DESCRIPTION_MAX_LENGTH = 600;

export const getPatientDeptOptions = (
    doctors:  Doctor[],
    selectedDoctorId: string,
    patientDepts: Dept[]
): DeptOptions[] => {
    const selectedDoctor = doctors.find(doctor => doctor._id === selectedDoctorId);
    const allowedDeptIds = selectedDoctor ? selectedDoctor.deptIds : [];

    return patientDepts
        .filter(dept => allowedDeptIds && allowedDeptIds.includes(dept._id))
        .map((el: Dept) => ({
            key: el._id,
            text: `${el.name}`,
            value: el._id,
        }));
};